import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dependent', 'inverseDependent', 'trigger']

  triggerTargetConnected(trigger) {
    trigger.addEventListener('change', this.#handleTrigger.bind(this))
    trigger.dispatchEvent(new Event('change'))
  }

  show(event) {
    this.#show(this.dependentTargets)
  }

  #handleTrigger(event) {
    if (event.target.checked) {
      this.#show(this.dependentTargets)
      this.#hide(this.inverseDependentTargets)
    } else {
      this.#hide(this.dependentTargets)
      this.#show(this.inverseDependentTargets)
    }
  }

  #hide(targets) {
    targets.forEach((target) => {
      target.classList.add('hidden')
    })
  }

  #show(targets) {
    targets.forEach((target) => {
      target.classList.remove('hidden')
    })
  }
}
